var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapital24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43988 14L8.07172 6.8418H9.51215L12.1049 14H10.7475L10.0395 11.9785H7.53461L6.82172 14H5.43988ZM7.86664 10.9922H9.70258C9.11664 9.11393 8.81553 8.14388 8.79926 8.08203L7.86664 10.9922ZM14.1606 14.1025C13.6625 14.1025 13.2589 13.9658 12.9496 13.6924C12.6437 13.4157 12.4907 13.0186 12.4907 12.501C12.4907 11.9443 12.673 11.5326 13.0375 11.2656C13.4021 10.9954 13.9523 10.8245 14.6879 10.7529C14.7888 10.7399 14.8979 10.7269 15.0151 10.7139C15.1323 10.7008 15.2641 10.6878 15.4106 10.6748C15.5571 10.6618 15.6726 10.6504 15.7573 10.6406V10.3574C15.7573 10.0319 15.6824 9.7959 15.5327 9.64941C15.3829 9.49967 15.155 9.4248 14.8491 9.4248C14.4129 9.4248 13.8741 9.54688 13.2328 9.79102C13.2296 9.78125 13.1759 9.63314 13.0717 9.34668C12.9675 9.06022 12.9138 8.91374 12.9106 8.90723C13.5421 8.63704 14.2257 8.50195 14.9614 8.50195C15.684 8.50195 16.2097 8.65983 16.5385 8.97559C16.8673 9.28809 17.0317 9.7959 17.0317 10.499V14H16.0844C16.0812 13.987 16.0453 13.8779 15.977 13.6729C15.9086 13.4678 15.8745 13.3587 15.8745 13.3457C15.6075 13.6061 15.3455 13.7982 15.0883 13.9219C14.8344 14.0423 14.5252 14.1025 14.1606 14.1025ZM14.5073 13.1943C14.8035 13.1943 15.0606 13.1243 15.2787 12.9844C15.5001 12.8411 15.658 12.6686 15.7524 12.4668V11.4316C15.7426 11.4316 15.6564 11.4382 15.4936 11.4512C15.3341 11.4642 15.2478 11.4707 15.2348 11.4707C14.7172 11.5163 14.338 11.6139 14.0971 11.7637C13.8562 11.9134 13.7358 12.1543 13.7358 12.4863C13.7358 12.7142 13.8025 12.89 13.936 13.0137C14.0694 13.1341 14.2599 13.1943 14.5073 13.1943Z",
    fill: "#11302D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#11302D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54547 18.5454H17.4546",
    stroke: "#11302D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapital24);
export default __webpack_public_path__ + "static/media/capital-24.37c6f58a894c5689a1734fd6d52f2fd1.svg";
export { ForwardRef as ReactComponent };